<template>
  <v-card style="height: 100%">
    <div class="card-body">
      <v-responsive :aspect-ratio="1">
        <div
          style="
            background-color: #eee;
            height: 100%;
            background-position: center;
            background-size: cover;
          "
          :style="{
            backgroundImage:
              'url(\'' +
              productImages[0] +
              '\'),url(\'/static/img/assets/_global/default-photo.png\')'
          }"
        >
          <v-layout>
            <v-flex>
              <modal-share-link
                :productid="product.id"
                :pageid="selectedBot.pageid"
              ></modal-share-link>
            </v-flex>
            <v-flex class="text-xs-right">
              <div
                class="text-xs-center sale-tag mr-2 white--text pa-2"
                style="display: inline-block; background: red; color: white; margin: auto"
                v-if="discountPercentage > 0"
              >
                {{ $t('Sale') }}
                <br />
                {{ discountPercentage | numberFormat }}%
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-responsive>

      <div style="position: relative">
        <div class="action" style="position: absolute; right: 10px; top: -20px">
          <v-btn
            fab
            depressed
            color="primary"
            small
            class="extra-small ma-1"
            @click="$emit('onSelectedProduct')"
            v-if="
              !(
                selectedBot.useketshop == true &&
                selectedBot.ketshop_api_key &&
                selectedBot.ketshop_api_secret
              )
            "
          >
            <em class="fa fa-pencil-alt middle" />
          </v-btn>
          <v-btn
            fab
            depressed
            color="primary"
            small
            class="extra-small ma-1"
            @click="onDeleteProduct(product.id)"
            v-if="
              !(
                selectedBot.useketshop == true &&
                selectedBot.ketshop_api_key &&
                selectedBot.ketshop_api_secret
              )
            "
          >
            <em class="fa fa-trash middle" />
          </v-btn>
        </div>
        <div style="padding: 15px">
          <div class="name" :title="product.name">{{ product.name }}</div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import StockItem from './StockItem.vue'
import ModalEditProduct from './ModalEditProduct'
import ModalShareLink from './ModalShareLink'
import numeral from 'numeral'

export default {
  props: ['value', 'category', 'selectCategory'],
  data: function () {
    return {
      product: this.value,

      showModal: false,
      showLink: false
    }
  },
  components: {
    ModalEditProduct,
    StockItem,
    ModalShareLink
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    productImages: function () {
      return this.product.photourl.split(';;')
    },
    currencySign: function () {
      if (this.product && this.product.currency) {
        switch (this.product.currency.toUpperCase()) {
          case 'THB':
            return '฿'
          case 'MMK':
            return 'K'

          default:
            return '$'
        }
      }
      return '$'
    },
    priceRange: function () {
      var min = 0
      var max = 0

      for (let index = 0; index < this.product.productstock.length; index++) {
        var price =
          this.product.productstock[index][3] == null || this.product.productstock[index][3] == ''
            ? parseFloat(this.product.price)
            : parseFloat(this.product.productstock[index][3])
        if (index == 0) {
          min = price
          max = price
        } else {
          if (price > max) {
            max = price
          }
          if (price < min) {
            min = price
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format('0,0.00')
      } else {
        return (
          this.currencySign +
          numeral(min).format('0,0.00') +
          ' - ' +
          this.currencySign +
          numeral(max).format('0,0.00')
        )
      }
    },
    discountPriceRange: function () {
      var min = 0
      var max = 0

      for (let index = 0; index < this.product.productstock.length; index++) {
        var price =
          this.product.productstock[index][3] == null || this.product.productstock[index][3] == ''
            ? parseFloat(this.product.discountprice)
            : parseFloat(this.product.productstock[index][3])
        var discountprice =
          this.product.productstock[index][4] == null || this.product.productstock[index][4] == ''
            ? price
            : parseFloat(this.product.productstock[index][4])

        if (index == 0) {
          min = discountprice
          max = discountprice
        } else {
          if (discountprice > max) {
            max = discountprice
          }
          if (discountprice < min) {
            min = discountprice
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format('0,0.00')
      } else {
        return (
          this.currencySign +
          numeral(min).format('0,0.00') +
          ' - ' +
          this.currencySign +
          numeral(max).format('0,0.00')
        )
      }
    },
    discountPercentage: function () {
      var max = 0

      for (let index = 0; index < this.product.productstock.length; index++) {
        var price =
          this.product.productstock[index][3] == null || this.product.productstock[index][3] == ''
            ? parseFloat(this.product.price)
            : parseFloat(this.product.productstock[index][3])
        var discountprice =
          this.product.productstock[index][4] == null || this.product.productstock[index][4] == ''
            ? price
            : parseFloat(this.product.productstock[index][4])

        if (index == 0) {
          max = ((price - discountprice) / price) * 100
        } else {
          var percent = ((price - discountprice) / price) * 100
          if (max < percent) {
            max = percent
          }
        }
      }

      return max
    },
    productstock: function () {
      return this.product.productstock.sort(function (a, b) {
        if (parseInt(a[6]) > parseInt(b[6])) {
          return 1
        } else if (parseInt(a[6]) < parseInt(b[6])) {
          return -1
        } else {
          return 0
        }
      })
    }
  },
  methods: {
    close: function () {
      let vm = this
      vm.showModal = false
      $('body').removeClass('modal-open')
      vm.$nextTick(function () {
        vm.$emit('input', vm.product)
      })
    },
    onDeleteProduct: function (id) {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: product.name ? vm.product.name.replace(/\<|\>/g, '') : ''
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            vm.$store.dispatch('loading')
            api.deleteProduct(id, function (error, response) {
              if (error) {
                vm.$store.dispatch('loading')
                console.error(error)
                return
              }

              vm.$emit('productDeleted')
              vm.$emit('close')
              vm.$store.dispatch('loading')
            })
          }
        })
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal != oldVal) {
        // this.product = this.value
      }
    },
    showModal: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ananda/Product.vue